import { getRgObjectsOfType as e, RG_TYPE as o } from "@project-rouge/rg-core";
import { getBuildingChildrenAtLevel as s } from "../../../utils/rg-util/index.js";
import { isBaseBuildObject as n } from "../../queries/index2.js";
import { isDoubleDoor as u } from "../../queries/index3.js";
const B = (t, i) => {
  const r = e(t, o.Building), l = s(r, i).filter(n);
  return e(l, o.Door).filter(u).length;
};
export {
  B as getLevelBaseBuildDoubleDoorsCount
};
//# sourceMappingURL=index5.js.map
